import { createContext, useContext, useState } from "react";

const UploadReceiptContext = createContext(null);

export const UPLOAD_RECEIPT_TERMS_STEP = 0;
export const UPLOAD_RECEIPT_UPLOAD_STEP = 1;
export const UPLOAD_RECEIPT_AMOUNT_VERIFY_STEP = 2;
export const UPLOAD_RECEIPT_AMOUNT_PROBLEM_STEP = 3;

export const UPLOAD_RECEIPT_WARNING_TYPE = 1;
export const UPLOAD_RECEIPT_DONATION_TYPE = 2;
export const UPLOAD_RECEIPT_INCREASE_CREDIT_TYPE = 3;

const defaultState = {
    openParentDialog: false,
    open: false,
    amount: "",
    amountUnit: null,
    uploadId: null,
    file: null,
    progress: -1,
    failed: null,
    finishedUpload: false,
    step: UPLOAD_RECEIPT_TERMS_STEP,
    type: null,
    warning: null,
};

export function UploadReceiptProvider({ children }) {
    const [state, setState] = useState(defaultState);

    return (
        <UploadReceiptContext.Provider value={[state, setState]}>
            {children}
        </UploadReceiptContext.Provider>
    );
}

export default function useUploadReceipt() {
    const [state, setState] = useContext(UploadReceiptContext);

    const openUploadReceiptDialog = (type, { warning = null } = {}) => {
        setState({
            ...defaultState,
            open: true,
            type,
            warning,
        });
    };

    const closeUploadReceiptDialog = ({ openParentDialog = false } = {}) => {
        setState({
            ...defaultState,
        });

        if (openParentDialog) {
            setState((prevState) => ({
                ...prevState,
                openParentDialog: true,
            }));

            setTimeout(() => {
                setState({
                    ...defaultState,
                });
            }, 500);
        }
    };

    const setAmount = (amount) => {
        setState((prevState) => ({
            ...prevState,
            amount,
        }));
    };

    const setAmountUnit = (amountUnit) => {
        setState((prevState) => ({
            ...prevState,
            amountUnit,
        }));
    };

    const setUploadId = (uploadId) => {
        setState((prevState) => ({
            ...prevState,
            uploadId,
        }));
    };

    const setFile = (file) => {
        setState((prevState) => ({
            ...prevState,
            file,
        }));
    };

    const setProgress = (progress) => {
        setState((prevState) => ({
            ...prevState,
            progress,
        }));
    };

    const setFailed = (failed) => {
        setState((prevState) => ({
            ...prevState,
            failed,
        }));
    };

    const goAmountVerifyStep = () => {
        setState((prevState) => ({
            ...prevState,
            step: UPLOAD_RECEIPT_AMOUNT_VERIFY_STEP,
        }));
    };

    const goUploadStep = () => {
        setState((prevState) => ({
            ...prevState,
            step: UPLOAD_RECEIPT_UPLOAD_STEP,
        }));
    };

    const goAmountProblemStep = () => {
        setState((prevState) => ({
            ...prevState,
            step: UPLOAD_RECEIPT_AMOUNT_PROBLEM_STEP,
        }));
    };

    const setFinishedUpload = (finishedUpload) => {
        setState((prevState) => ({
            ...prevState,
            finishedUpload,
        }));
    };

    return {
        openParentDialog: state?.openParentDialog,
        type: state?.type,
        warning: state?.warning,
        step: state?.step,
        file: state?.file,
        setFile,
        progress: state?.progress,
        setProgress,
        finishedUpload: state?.finishedUpload,
        setFinishedUpload,
        failed: state?.failed,
        setFailed,
        uploadId: state?.uploadId,
        setUploadId,
        amount: state?.amount,
        setAmount,
        amountUnit: state?.amountUnit,
        setAmountUnit,
        isUploadReceiptDialogOpen: state?.open,
        openUploadReceiptDialog,
        closeUploadReceiptDialog,
        goAmountVerifyStep,
        goUploadStep,
        goAmountProblemStep,
    };
}
